import React from "react";
import { ActivityIcon } from "./PrivacyIcons";
import ReusableTable from "../shared/ReusableTable";

const AUDIT_DATA = [
  { action: "Password changed", date: "2024-01-15", time: "09:30 AM", ip: "192.168.1.1" },
  { action: "Login from new device", date: "2024-01-14", time: "10:15 AM", ip: "192.168.1.2" },
  { action: "Profile updated", date: "2024-01-13", time: "08:45 AM", ip: "192.168.1.1" },
  { action: "2FA enabled", date: "2024-01-12", time: "11:00 AM", ip: "192.168.1.1" },
  { action: "Email address verified", date: "2024-01-11", time: "09:00 AM", ip: "192.168.1.1" },
];

const AUDIT_COLUMNS = [
  { key: "action", label: "Action" },
  { key: "date", label: "Date" },
  { key: "time", label: "Time" },
  {
    key: "ip",
    label: "IP Address",
    render: (val) => <code className="v2-shared-tbl__ip">{val}</code>,
  },
];

const PrivacyAuditLog = () => {
  return (
    <div className="v2-privacy-pg-card">
      <div className="v2-privacy-pg-card__header">
        <div className="v2-privacy-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <ActivityIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-privacy-pg-card__title">Audit Log</h3>
          <p className="v2-privacy-pg-card__subtitle">Recent account activity</p>
        </div>
      </div>
      <ReusableTable columns={AUDIT_COLUMNS} data={AUDIT_DATA} />
    </div>
  );
};

export default PrivacyAuditLog;
